(function (app, ng) {

    app.component("editStockQuestionPlugin",
        {
            controller: configureStockQuestionPluginController,
            templateUrl: "/App/Dashboard/ManageStockQuestions/ConfigureStockQuestions/ManageStockQuestionPlugins/template.html",
            bindings: {
                question: "<",
                onSave: "&",
                firelightQuestion: "<",
                //TODO: Remove when rightbridge is 100% gone
                rightBridgeQuestion: "<"
            }
        });

    configureStockQuestionPluginController.$inject = ["$state", "$mdDialog", "stockQuestionApi", "$q", "productPlugins"];

    function configureStockQuestionPluginController($state, $mdDialog, stockQuestionApi, $q, productPlugins) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                save: save,
                UI: {
                    View: productPlugins[0].ShortName
                },
                productPlugins: productPlugins,
                toggleView: toggleView,
                selectMapping: selectMapping
            });

        this.$onInit = function () {
            $ctrl.onSave({
                $func: function () {
                    return save();
                }
            });
            if ($ctrl.question.Plugins) {
                ng.forEach($ctrl.question.Plugins, function (p) {
                    var plugin = _.find($ctrl.productPlugins, function (row) {
                        return row.ShortName === p;
                    });

                    if (plugin)
                        plugin.IsActive = true;
                });
            }

            if ($ctrl.question.StockQuestionPossibleAnswers.length > 0) {
                $ctrl.selectedFLAnswer = $ctrl.question.StockQuestionPossibleAnswers[0].Value;
                $ctrl.selectedRBAnswer = $ctrl.question.StockQuestionPossibleAnswers[0].Value;
            }
        };

        function save() {
            $ctrl.UI.isSaving = true;
            $ctrl.question.Plugins = [];
            ng.forEach($ctrl.productPlugins, function (p) {
                if (p.IsActive)
                    $ctrl.question.Plugins.push(p.ShortName);
            });
            return stockQuestionApi.updateStockQuestion($ctrl.question).then(function () {
                var promises = [];
                promises.push(stockQuestionApi.updateFirelightQuestion($ctrl.firelightQuestion));
                promises.push(stockQuestionApi.updateRightBridgeQuestion($ctrl.rightBridgeQuestion));
                return $q.all(promises).then(function () {
                    //close();
                });
            });
        }

        function toggleView(index) {
            $ctrl.UI.View = $ctrl.productPlugins[index].ShortName;
        }

        function selectMapping(plugin, index) {
            if (plugin === 'FL')
                $ctrl.selectedFLAnswer = $ctrl.question.StockQuestionPossibleAnswers[index].Value;
            else
                $ctrl.selectedRBAnswer = $ctrl.question.StockQuestionPossibleAnswers[index].Value;
        }
    }

})(window.app, window.angular); //jshint ignore:line